const TrackReferral = () => {
  return (
    <embed
      style={{ width: "100%", height: "calc(100vh - 60px)" }}
      src="https://embed.referral-factory.com/UeFeb8/referrals"
    />
  );
};
export default TrackReferral;
